import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { reactRecursiveChildrenMap } from "./utils";
export class SVGUniqueID extends React.Component {
  constructor() {
    super(...arguments);
    this.svgId = Math.random().toString(16).slice(2, 8);
    this.lastLocalId = 0;
    this.localIdsMap = new Map();
  }
  getHookedId(originalId) {
    if (typeof originalId === 'undefined') {
      return null;
    }
    if (!this.localIdsMap.has(originalId)) {
      this.localIdsMap.set(originalId, this.lastLocalId++);
    }
    var localId = this.localIdsMap.get(originalId);
    return this.svgId + "_" + localId;
  }
  fixPropWithUrl(prop) {
    if (typeof prop !== 'string') {
      return prop;
    }
    var [_, id] = prop.match(/^url\(#(.*)\)$/) || [null, null];
    if (id === null) {
      return prop;
    }
    var fixedId = this.getHookedId(id);
    if (fixedId === null) {
      return prop;
    }
    return "url(#" + fixedId + ")";
  }
  getHookedXlinkHref(prop) {
    if (typeof prop !== 'string' || !prop.startsWith('#')) {
      return prop;
    }
    var id = prop.replace('#', '');
    var fixedId = this.getHookedId(id);
    if (fixedId === null) {
      return prop;
    }
    return "#" + fixedId;
  }
  render() {
    var originalChildren = this.props.children;
    if (! /*#__PURE__*/React.isValidElement(originalChildren)) {
      return null;
    }
    var children = originalChildren.type === 'svg' || originalChildren.props.tagName === 'svg' ? originalChildren.props.children : originalChildren;
    return /*#__PURE__*/React.cloneElement(originalChildren, _extends({}, originalChildren.props), reactRecursiveChildrenMap(children, child => {
      // @ts-ignore
      if (!child || typeof child === 'string' || typeof child === 'number' || !('props' in child)) {
        return child;
      }
      var fixedId = this.getHookedId(child.props.id);
      var fixedProps = _extends({}, child.props);
      Object.keys(fixedProps).map(key => fixedProps[key] = this.fixPropWithUrl(fixedProps[key]));
      return /*#__PURE__*/React.cloneElement(child, _extends({}, fixedProps, {
        id: fixedId,
        xlinkHref: this.getHookedXlinkHref(child.props.xlinkHref)
      }));
    }));
  }
}
export default SVGUniqueID;